import React from 'react';
import { ButtonComponent } from './ButtonComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons';
import './PagePlaceholder.scss';

interface PagePlaceholderProps {
  top?: number | string;
  left?: number | string;
  additionalClass?: string;
}

export const PagePlaceholder = (props: PagePlaceholderProps): JSX.Element => {
  const handleRefresh = (): void => {
    window.location.reload();
  };

  return (
      <div className="page-placeholder">
        <div className="fs-4 mb-5">Please refresh the page to update data.</div>

        <span className="text-danger d-flex align-items-center cursor-pointer" onClick={handleRefresh}>
          <FontAwesomeIcon icon={faRotateRight} className="me-2" />
          <div className="fs-6 fw-bolder">Refresh</div>
        </span>
      </div>
  );
};
